import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";
import { getProfile } from "../../utils/pip";
import ChatPage from "../common/ChatPage";
import { SocketBootstrap } from "../../components/chat/SocketBootstrap";
import HireTalentLayout from "../../layouts/HireTalentLayout";
import { useEffect } from "react";
import { setActiveChat } from "../../redux/features/chat/chatSlice";
const Inbox = () => {
  const dispatch = useDispatch()
  const user = getProfile("hire-talent");

  const { subLoading } = useSelector((state) => state.hireTalent.auth);

  useEffect(() => {
    return () => {
      dispatch(setActiveChat(null));
    };
  }, [dispatch]);
  return (
    <div>
      <HireTalentLayout>
         {subLoading && <Loader />}
         <SocketBootstrap role="hire-talent" />
        <ChatPage userId={user.user_id} role={"hire-talent"} />
      </HireTalentLayout>
    </div>
  );
};

export default Inbox;
